// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 8 ? "mobile" : chunkId) + "." + {"8":"c7b7ec84","103":"ac03f27b","881":"8fd07532","955":"8165d950"}[chunkId] + ".css";
};